export default class LmsConfigurationDomainService {
    static fromJSON(json) {
        return Object.assign({}, json);
    }
    static displayValue(lmsConfiguration) {
        let value;
        if (lmsConfiguration.longValue) {
            value = lmsConfiguration.longValue.toString();
        }
        else if (lmsConfiguration.booleanValue) {
            value = lmsConfiguration.booleanValue.toString();
        }
        else {
            value = lmsConfiguration.stringValue;
        }
        return lmsConfiguration.hidden ? "******" : value;
    }
    static getValue(lmsConfiguration) {
        if (lmsConfiguration.longValue) {
            return lmsConfiguration.longValue;
        }
        if (lmsConfiguration.booleanValue) {
            return lmsConfiguration.booleanValue;
        }
        return lmsConfiguration.stringValue;
    }
    static get stringFieldTypeId() {
        return 1;
    }
    static get longFieldTypeId() {
        return 2;
    }
    static get booleanFieldTypeId() {
        return 3;
    }
}
